<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="历史日流量" name="first">
      <el-form :model="queryParams"  :inline="true">
        <el-form-item  prop="dateRange">
            <el-date-picker
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="dateRange"
              @change="search"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
      </el-form>
      <div id="dayChart" :class="className" :style="{height:height,width:width}" />
    </el-tab-pane>
    <el-tab-pane label="运营商历史日流量" name="second" v-if="operationName!='国际' && checkPermi(['card:info:carrierDayFlow'])">
      <el-button type="primary" :loading="loading" @click="refresh">{{loading?'加载中':'刷新'}}</el-button>
      <div id="carrierDayChart" :style="{height:height,width:width}" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import * as echarts from "echarts"
import resize from '@/views/dashboard/mixins/resize'
import {lineChartCardFlow , carrierCardFlowDay} from "@/api/api.js"; //卡流量数据
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    iccid: {
      type: String,
    },
    operationName: {
      type: String,
      default: ''
    }

  },
  data() {
    return {
      chart:null,
      carrierChart:null,
      queryParams:{
        iccid:this.iccid,
        type:'1'
      },
      dateRange:[],
      activeName:'first',
      loading:false
    }
  },
  beforeDestroy() {
    if (!!this.chart) {
      this.chart.dispose()
      this.chart = null
    }
    if (!!this.carrierChart) {
      this.carrierChart.dispose()
      this.carrierChart = null
    }
    
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
      if(this.operationName!='国际' && this.checkPermi(['card:info:carrierDayFlow'])){
        this.initCarrierChart()
      }
    })
  },
  watch: {
    iccid() {
      this.queryParams.iccid = this.iccid
      this.initChart()
    }
  },
  methods: {
    initChart() {
      // this.chart = echarts.init(this.$el)

      document.getElementById("dayChart").style.width = (window.innerWidth / 7) * 5 + 'px';// 宽度
      this.chart = echarts.init(document.getElementById("dayChart"))
      let that =  this
      if(!this.chart ){
        return;
      }
      lineChartCardFlow(this.queryParams).then(res=>{
        if(that.chart){
          that.setOptions(that.chart,res.data.data)
          that.chart.resize();
        }
      })
    },
    initCarrierChart(){
      this.loading = true
      let that = this
      document.getElementById("carrierDayChart").style.width = (window.innerWidth / 7) * 5 + 'px';// 宽度
      this.carrierChart = echarts.init(document.getElementById("carrierDayChart"))
      if(!this.carrierChart ){
        return;
      }
      carrierCardFlowDay(this.queryParams).then(res=>{
          that.loading = false
          if (that.carrierChart){
            that.setOptions(that.carrierChart,res.data.data);
            that.carrierChart.resize();
          }
      })
    },
    refresh(){
      this.initCarrierChart()
    },
    setOptions(chart,{timeList,monthList}={}) {
      chart.setOption({
        title: {
          text: '流量统计',
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: [{
              name: this.iccid,
              // 设置文本为红色
              textStyle: {
                  color: 'red',
                  fontSize:16
              }
          }]
        },
        toolbox: {
          show: true,
          feature: {
            magicType: { show: true, type: ['line', 'bar'] },
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: timeList
          }
        ],
        yAxis: [
          {
            type: 'value',
            position: 'left',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#1890ff'
              }
            },
            axisLabel: {
              formatter: '{value} MB'
            }
          }
        ],
        series: [
          {
            name: this.iccid,
            type: 'bar',
            data: monthList,
            label: {
              show: true,
                position: "top",  // 展示在柱子的上方
                distance: 6,  //与柱子之间的距离
                fontSize: 14,  
                color: "#1890ff",
            }
          }
        ]
      });

    },
    // 搜索
    search() {
      let param = this.addDateRange(this.queryParams, this.dateRange)
      document.getElementById("dayChart").style.width = (window.innerWidth / 7) * 5 + 'px';// 宽度
      let chart = echarts.init(document.getElementById("dayChart"))
      lineChartCardFlow(param).then(res=>{
          this.setOptions(chart,res.data.data)
      })
    },
  }
}
</script>